import { NavLink } from 'react-router-dom'

type Props = {
  title: string
  id: number
}

export const OptionMobile = ({ title, id }: Props) => {
  return (
    <NavLink
      to={String(id)}
      className="block text-start  w-full h-[52px] p-4 rounded-xl text-base bg-grey-50 text-grey-900 font-normal"
    >
      <span className="block gap-4">{`${id} - ${title}`}</span>
    </NavLink>
  )
}
